import { z } from 'zod';
import { emailSchema, optionalText, urlSchema, auditFields } from '../common.js';

export const userProfileSchema = z.object({
  type: z.literal('User'),
  userId: z.string(),
  email: emailSchema,
  name: optionalText,
  avatarUrl: urlSchema.optional(),
  locale: z.enum(['en', 'es']).default('en'),
  /**
   * The weekly checklist reminder. On by default: somebody planning a wedding in
   * a tool built around a dated checklist is asking to be reminded of it, and a
   * reminder nobody opted into is still one click from being off — every mail
   * carries the link, and `List-Unsubscribe` makes it one click inside Gmail.
   */
  weeklyEmail: z.boolean().default(true),
  ...auditFields,
});
export type UserProfile = z.infer<typeof userProfileSchema>;

export const updateProfileSchema = z.object({
  name: optionalText,
  locale: z.enum(['en', 'es']).optional(),
  weeklyEmail: z.boolean().optional(),
});
export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;
